/* eslint-disable no-sequences */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './sidebar.scss';
import { FaHome, FaRegBell, FaRegCalendarAlt, FaRegNewspaper, FaRegUser, FaSitemap, } from 'react-icons/fa';

import { AiOutlinePieChart as FaChartPie } from 'react-icons/ai';
import { FiLock as FaLightbulb } from 'react-icons/fi';
import { BsController } from 'react-icons/bs';

import AuthContext from '../../auth/index';
import { MdContentCopy } from 'react-icons/md';
import { hasAdminRole, hasGestorSSERole } from "../../utils/hasPermission";
import { useApp } from "../../context/app";
import { inPersistentStore } from "../../utils/storage.util";

const ICON_SIZE = 16;

const pages = {
  auth: [
    {
      url: '/',
      description: 'Home',
      bgcColor: '#808080',
      icon: (isSelected) => (
        <FaHome size={ICON_SIZE} color={isSelected ? '#fff' : '#808080'} />
      ),
    },
  ],
  notAuth: [
    {
      url: '/dashboard',
      description: 'Home',
      bgcColor: '#0061c6',
      isPublicAccess: true,
      allowedAccessGestorSSE: true,
      icon: (isSelected) => (
        // <FaHome size={ICON_SIZE} color={isSelected ? "#fff" : "#0061c6"} />

        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          stroke={isSelected ? '#fff' : '#0061c6'}
          xmlns="http://www.w3.org/2000/svg"
          style={{ color: isSelected ? '#fff' : '#0061c6' }}
        >
          <path
            d="M14.5972 6.52428C14.5967 6.52393 14.5964 6.52348 14.596 6.52313L8.47659 0.404549C8.21576 0.143623 7.86897 0 7.50009 0C7.13121 0 6.78441 0.143623 6.52346 0.404549L0.407237 6.52004C0.405177 6.5221 0.403003 6.52428 0.401057 6.52634C-0.134581 7.06501 -0.133665 7.939 0.403689 8.4763C0.64919 8.72189 0.973319 8.86402 1.32 8.87901C1.33419 8.88039 1.34838 8.88107 1.36269 8.88107H1.60647V13.3839C1.60647 14.275 2.33164 15 3.22288 15H5.617C5.85975 15 6.0565 14.8032 6.0565 14.5605V11.0303C6.0565 10.6237 6.38738 10.2929 6.79403 10.2929H8.20614C8.61279 10.2929 8.94356 10.6237 8.94356 11.0303V14.5605C8.94356 14.8032 9.1403 15 9.38306 15H11.7772C12.6685 15 13.3936 14.275 13.3936 13.3839V8.88107H13.6197C13.9885 8.88107 14.3353 8.73745 14.5964 8.47641C15.1343 7.93831 15.1345 7.06272 14.5972 6.52428ZM13.9748 7.855C13.8799 7.94987 13.7538 8.00217 13.6197 8.00217H12.9541C12.7113 8.00217 12.5146 8.19889 12.5146 8.44162V13.3839C12.5146 13.7904 12.1838 14.1211 11.7772 14.1211H9.82256V11.0303C9.82256 10.1391 9.0975 9.41402 8.20614 9.41402H6.79403C5.90267 9.41402 5.1775 10.1391 5.1775 11.0303V14.1211H3.22288C2.81635 14.1211 2.48547 13.7904 2.48547 13.3839V8.44162C2.48547 8.19889 2.28872 8.00217 2.04597 8.00217H1.39176C1.38489 8.00171 1.37814 8.00137 1.37116 8.00125C1.24022 7.99896 1.11741 7.94701 1.0254 7.85488C0.829681 7.65919 0.829681 7.3407 1.0254 7.14489C1.02551 7.14489 1.02551 7.14478 1.02562 7.14466L1.02597 7.14432L7.14517 1.02596C7.23994 0.931091 7.36595 0.878906 7.50009 0.878906C7.63411 0.878906 7.76012 0.931091 7.855 1.02596L13.9728 7.14306C13.9737 7.14397 13.9748 7.14489 13.9757 7.14581C14.1704 7.34184 14.17 7.65965 13.9748 7.855Z"
            fill="#B3B3B3"
          />
        </svg>
      ),
    },
    {
      url: '/cards',
      description: 'Cards',
      bgcColor: '#99CCCC',
      icon: (isSelected) => (
        // <FaRegAddressCard
        //   size={ICON_SIZE}
        //   color={isSelected ? "#fff" : "#99CCCC"}
        // />
        <svg
          width="15"
          height="12"
          viewBox="0 0 15 12"
          fill="none"
          stroke={isSelected ? '#fff' : '#99CCCC'}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1.19452 3.12913V2.36161C1.19452 1.71217 1.72324 1.1808 2.36945 1.1808H12.6697C13.3159 1.1808 13.8446 1.71217 13.8446 2.36161V3.12913H1.2141H1.19452ZM14.4125 6.35666C14.7258 6.35666 15 6.10082 15 5.76626V2.36161C15 1.06272 13.9426 0 12.6501 0H2.34987C1.05744 0 0 1.06272 0 2.36161V8.71827C0 10.0172 1.05744 11.0799 2.34987 11.0799H12.6501C13.9426 11.0799 15 10.0172 15 8.71827C15 8.40339 14.7454 8.12787 14.4125 8.12787C14.0992 8.12787 13.8251 8.38371 13.8251 8.71827C13.8251 9.36772 13.2963 9.89908 12.6501 9.89908H2.34987C1.70366 9.89908 1.17493 9.36772 1.17493 8.71827V4.30994H13.8055V5.78594C13.8055 6.10082 14.0601 6.37634 14.393 6.37634L14.4125 6.35666Z"
            fill="#99CCCC"
          />
        </svg>
      ),
    },
    {
      url: '/carrossel',
      description: 'Carrosséis',
      bgcColor: '#33CC99',
      icon: (isSelected) => (
        // <FaSlidersH size={ICON_SIZE} color={isSelected ? "#fff" : "#33CC99"} />
        <svg
          width="12"
          height="15"
          viewBox="0 0 12 15"
          fill="none"
          stroke={isSelected ? '#fff' : '#33CC99'}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.75675 2.85449H10.1145C10.837 2.85449 11.415 3.52614 11.415 4.36569V13.4888C11.415 14.3283 10.837 15 10.1145 15H3.75675C3.03428 15 2.4563 14.3283 2.4563 13.4888V4.36569C2.4563 3.52614 3.03428 2.85449 3.75675 2.85449ZM3.66042 4.1418H10.2109V13.6567H3.66042V4.1418Z"
            fill="#33CC99"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M1.30045 0.0559713H8.47702V1.34328H1.20412V10.8582H0V1.51119C0 0.671643 0.577979 0 1.30045 0V0.0559713Z"
            fill="#33CC99"
          />
        </svg>
      ),
    },
    {
      url: '/cupons',
      description: 'Cupons',
      bgcColor: '#9999FF',
      icon: (isSelected) => (
        // <FaSlidersH size={ICON_SIZE} color={isSelected ? "#fff" : "#9999FF"} />
        <svg
          width="15"
          height="11"
          viewBox="0 0 15 11"
          fill="none"
          stroke={isSelected ? '#fff' : '#9999FF'}
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_53_556" fill="white">
            <path d="M13.5937 11H1.40626C0.63081 11 0 10.3832 0 9.625V7.33332C0 7.07998 0.209649 6.87499 0.468752 6.87499C1.2442 6.87499 1.87501 6.2582 1.87501 5.49999C1.87501 4.74177 1.2442 4.12498 0.468752 4.12498C0.209649 4.12501 0 3.92002 0 3.66668V1.375C0 0.616791 0.63081 0 1.40626 0H13.5937C14.3692 0 15 0.616791 15 1.375V3.66668C15 3.92002 14.7904 4.12501 14.5312 4.12501C13.7558 4.12501 13.125 4.7418 13.125 5.50002C13.125 6.25823 13.7558 6.87502 14.5312 6.87502C14.7904 6.87502 15 7.08001 15 7.33335V9.62503C15 10.3832 14.3692 11 13.5937 11ZM0.937504 7.74556V9.625C0.937504 9.87788 1.14763 10.0833 1.40626 10.0833H13.5937C13.8524 10.0833 14.0625 9.87788 14.0625 9.625V7.74556C12.9941 7.53251 12.1875 6.60689 12.1875 5.49999C12.1875 4.39308 12.9941 3.46749 14.0625 3.25441V1.375C14.0625 1.12212 13.8524 0.916669 13.5937 0.916669H1.40626C1.14763 0.916669 0.937504 1.12212 0.937504 1.375V3.25444C2.00592 3.46749 2.81251 4.39311 2.81251 5.50002C2.81251 6.60693 2.00592 7.53251 0.937504 7.74556Z" />
          </mask>
          <path
            d="M13.5937 11H1.40626C0.63081 11 0 10.3832 0 9.625V7.33332C0 7.07998 0.209649 6.87499 0.468752 6.87499C1.2442 6.87499 1.87501 6.2582 1.87501 5.49999C1.87501 4.74177 1.2442 4.12498 0.468752 4.12498C0.209649 4.12501 0 3.92002 0 3.66668V1.375C0 0.616791 0.63081 0 1.40626 0H13.5937C14.3692 0 15 0.616791 15 1.375V3.66668C15 3.92002 14.7904 4.12501 14.5312 4.12501C13.7558 4.12501 13.125 4.7418 13.125 5.50002C13.125 6.25823 13.7558 6.87502 14.5312 6.87502C14.7904 6.87502 15 7.08001 15 7.33335V9.62503C15 10.3832 14.3692 11 13.5937 11ZM0.937504 7.74556V9.625C0.937504 9.87788 1.14763 10.0833 1.40626 10.0833H13.5937C13.8524 10.0833 14.0625 9.87788 14.0625 9.625V7.74556C12.9941 7.53251 12.1875 6.60689 12.1875 5.49999C12.1875 4.39308 12.9941 3.46749 14.0625 3.25441V1.375C14.0625 1.12212 13.8524 0.916669 13.5937 0.916669H1.40626C1.14763 0.916669 0.937504 1.12212 0.937504 1.375V3.25444C2.00592 3.46749 2.81251 4.39311 2.81251 5.50002C2.81251 6.60693 2.00592 7.53251 0.937504 7.74556Z"
            fill="#9999FF"
          />
          <path
            d="M0.468752 4.12498V2.12498H0.468514L0.468752 4.12498ZM15 9.62503L17 9.62511V9.62503H15ZM14.0625 7.74556H16.0625V6.10499L14.4536 5.78417L14.0625 7.74556ZM14.0625 3.25441L14.4536 5.21579L16.0625 4.89495V3.25441H14.0625ZM0.937504 3.25444H-1.0625V4.89501L0.546399 5.21583L0.937504 3.25444ZM13.5937 9H1.40626V13H13.5937V9ZM1.40626 9C1.69277 9 2 9.2365 2 9.625H-2C-2 11.5299 -0.431148 13 1.40626 13V9ZM2 9.625V7.33332H-2V9.625H2ZM2 7.33332C2 8.22668 1.27161 8.87499 0.468752 8.87499V4.87499C-0.852314 4.87499 -2 5.93328 -2 7.33332H2ZM0.468752 8.87499C2.30616 8.87499 3.87501 7.4049 3.87501 5.49999H-0.124992C-0.124992 5.11149 0.182241 4.87499 0.468752 4.87499V8.87499ZM3.87501 5.49999C3.87501 3.59507 2.30616 2.12498 0.468752 2.12498V6.12498C0.182241 6.12498 -0.124992 5.88848 -0.124992 5.49999H3.87501ZM0.468514 2.12498C1.2716 2.12489 2 2.77336 2 3.66668H-2C-2 5.06669 -0.852301 6.12514 0.46899 6.12498L0.468514 2.12498ZM2 3.66668V1.375H-2V3.66668H2ZM2 1.375C2 1.7635 1.69277 2 1.40626 2V-2C-0.431149 -2 -2 -0.529914 -2 1.375H2ZM1.40626 2H13.5937V-2H1.40626V2ZM13.5937 2C13.3072 2 13 1.7635 13 1.375H17C17 -0.529915 15.4311 -2 13.5937 -2V2ZM13 1.375V3.66668H17V1.375H13ZM13 3.66668C13 2.77332 13.7284 2.12501 14.5312 2.12501V6.12501C15.8523 6.12501 17 5.06673 17 3.66668H13ZM14.5312 2.12501C12.6938 2.12501 11.125 3.5951 11.125 5.50002H15.125C15.125 5.88851 14.8178 6.12501 14.5312 6.12501V2.12501ZM11.125 5.50002C11.125 7.40494 12.6938 8.87502 14.5312 8.87502V4.87502C14.8178 4.87502 15.125 5.11152 15.125 5.50002H11.125ZM14.5312 8.87502C13.7284 8.87502 13 8.22671 13 7.33335H17C17 5.9333 15.8523 4.87502 14.5312 4.87502V8.87502ZM13 7.33335V9.62503H17V7.33335H13ZM13 9.62494C13 9.2365 13.3072 9 13.5937 9V13C15.4312 13 16.9999 11.5299 17 9.62511L13 9.62494ZM-1.0625 7.74556V9.625H2.9375V7.74556H-1.0625ZM-1.0625 9.625C-1.0625 11.0246 0.0856688 12.0833 1.40626 12.0833V8.08333C2.20958 8.08333 2.9375 8.73117 2.9375 9.625H-1.0625ZM1.40626 12.0833H13.5937V8.08333H1.40626V12.0833ZM13.5937 12.0833C14.9143 12.0833 16.0625 11.0246 16.0625 9.625H12.0625C12.0625 8.73117 12.7904 8.08333 13.5937 8.08333V12.0833ZM16.0625 9.625V7.74556H12.0625V9.625H16.0625ZM14.4536 5.78417C14.2695 5.74746 14.1875 5.60199 14.1875 5.49999H10.1875C10.1875 7.6118 11.7186 9.31756 13.6714 9.70694L14.4536 5.78417ZM14.1875 5.49999C14.1875 5.398 14.2695 5.25252 14.4536 5.21579L13.6713 1.29304C11.7186 1.68246 10.1875 3.38816 10.1875 5.49999H14.1875ZM16.0625 3.25441V1.375H12.0625V3.25441H16.0625ZM16.0625 1.375C16.0625 -0.0245864 14.9143 -1.08333 13.5937 -1.08333V2.91667C12.7904 2.91667 12.0625 2.26883 12.0625 1.375H16.0625ZM13.5937 -1.08333H1.40626V2.91667H13.5937V-1.08333ZM1.40626 -1.08333C0.0856674 -1.08333 -1.0625 -0.0245815 -1.0625 1.375H2.9375C2.9375 2.26883 2.20959 2.91667 1.40626 2.91667V-1.08333ZM-1.0625 1.375V3.25444H2.9375V1.375H-1.0625ZM0.546399 5.21583C0.730475 5.25254 0.812512 5.39801 0.812512 5.50002H4.81251C4.81251 3.38821 3.28136 1.68244 1.32861 1.29306L0.546399 5.21583ZM0.812512 5.50002C0.812512 5.60199 0.730508 5.74746 0.546399 5.78417L1.32861 9.70694C3.28132 9.31757 4.81251 7.61186 4.81251 5.50002H0.812512Z"
            fill="#9999FF"
            mask="url(#path-1-inside-1_53_556)"
          />
        </svg>
      ),
    },
    {
      url: '/diagnosticos',
      description: 'Diagnósticos',
      bgcColor: '#CC66CC',
      icon: (isSelected) => (
        // <FaChartBar size={ICON_SIZE} color={isSelected ? "#fff" : "#CC66CC"} />
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          stroke={isSelected ? '#fff' : '#CC66CC'}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.257 2.23917C11.5675 2.23917 11.816 1.99049 11.816 1.67965C11.816 1.3688 11.5675 1.12012 11.257 1.12012C10.9464 1.12012 10.698 1.3688 10.698 1.67965C10.698 1.99049 10.9464 2.23917 11.257 2.23917Z"
            fill="#CC66CC"
          />
          <path
            d="M9.70447 7.95895L9.14549 9.63759L8.58651 7.95895C8.5244 7.71026 8.33808 7.58593 8.08964 7.58593H7.40645L6.41271 3.66909C6.3506 3.4204 6.16427 3.23389 5.91583 3.23389C5.6674 3.23389 5.48107 3.4204 5.41896 3.66909L4.42522 7.58593H2.68618C2.37563 7.58593 2.1272 7.83462 2.1272 8.14548C2.1272 8.45634 2.37563 8.70503 2.68618 8.70503H4.85998C5.10842 8.70503 5.29475 8.51849 5.35685 8.2698L5.91583 6.03163L6.47481 8.2698C6.53692 8.51849 6.72325 8.70503 6.97168 8.70503H7.65488L8.58651 11.5649C8.64862 11.8136 8.83495 11.938 9.08338 11.938C9.33182 11.938 9.51815 11.8136 9.58025 11.5649L10.5119 8.70503H12.2509C12.5615 8.70503 12.8099 8.45634 12.8099 8.14548C12.8099 7.83462 12.5615 7.58593 12.2509 7.58593H10.0771C9.82869 7.58593 9.64236 7.71026 9.58025 7.95895H9.70447Z"
            fill="#CC66CC"
          />
          <path
            d="M12.4994 2.73659C12.251 2.92311 12.251 3.23399 12.4373 3.48267C14.549 6.03172 14.3627 9.76202 12.0025 12.1246C9.51817 14.6114 5.41899 14.6114 2.87253 12.1246C0.38818 9.63768 0.38818 5.53433 2.87253 2.98529C4.48736 1.36882 6.90961 0.747099 9.14552 1.30665C9.45607 1.36882 9.7045 1.24449 9.82872 0.93363C9.89083 0.622771 9.76661 0.37408 9.45607 0.249736C6.8475 -0.434154 4.0526 0.311893 2.18934 2.17705C-0.729779 5.09912 -0.729779 9.88637 2.18934 12.8084C5.10845 15.7305 9.89083 15.7305 12.8099 12.8084C15.5427 10.0729 15.7291 5.65867 13.3068 2.73659C13.1205 2.48791 12.8099 2.48792 12.5615 2.67443L12.4994 2.73659Z"
            fill="#CC66CC"
          />
        </svg>
      ),
    },
    {
      url: '/eventos',
      description: 'Eventos',
      bgcColor: '#FF0000',
      icon: (isSelected) => (
        <FaRegCalendarAlt
          size={ICON_SIZE}
          color={isSelected ? '#fff' : '#FF0000'}
        />
      ),
    },
    {
      url: '/funcionalidades',
      description: 'Funcionalidades',
      bgcColor: '#CC3366',
      icon: (isSelected) => (
        // <FaColumns size={ICON_SIZE} color={isSelected ? "#fff" : "#CC3366"} />
        <svg
          width="15"
          height="15"
          viewBox="0 0 15 15"
          fill="none"
          stroke={isSelected ? '#fff' : '#CC3366'}
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask id="path-1-inside-1_53_585" fill="white">
            <path d="M5.45455 0H1.36365C0.611558 0 0 0.611558 0 1.36365V5.45455C0 6.20661 0.611558 6.8182 1.36365 6.8182H5.45455C6.20661 6.8182 6.8182 6.20664 6.8182 5.45455V1.36365C6.81817 0.611558 6.20661 0 5.45455 0ZM6.13636 5.45455C6.13636 5.8304 5.8304 6.13636 5.45455 6.13636H1.36365C0.987794 6.13636 0.681839 5.8304 0.681839 5.45455V1.36365C0.681839 0.987794 0.987794 0.681839 1.36365 0.681839H5.45455C5.8304 0.681839 6.13636 0.987794 6.13636 1.36365V5.45455Z" />
          </mask>
          <path
            d="M5.45455 0H1.36365C0.611558 0 0 0.611558 0 1.36365V5.45455C0 6.20661 0.611558 6.8182 1.36365 6.8182H5.45455C6.20661 6.8182 6.8182 6.20664 6.8182 5.45455V1.36365C6.81817 0.611558 6.20661 0 5.45455 0ZM6.13636 5.45455C6.13636 5.8304 5.8304 6.13636 5.45455 6.13636H1.36365C0.987794 6.13636 0.681839 5.8304 0.681839 5.45455V1.36365C0.681839 0.987794 0.987794 0.681839 1.36365 0.681839H5.45455C5.8304 0.681839 6.13636 0.987794 6.13636 1.36365V5.45455Z"
            fill="#CC3366"
          />
          <path
            d="M6.8182 1.36365H7.8182V1.3636L6.8182 1.36365ZM5.45455 -1H1.36365V1H5.45455V-1ZM1.36365 -1C0.0592737 -1 -1 0.0592737 -1 1.36365H1C1 1.16384 1.16384 1 1.36365 1V-1ZM-1 1.36365V5.45455H1V1.36365H-1ZM-1 5.45455C-1 6.75888 0.0592587 7.8182 1.36365 7.8182V5.8182C1.16386 5.8182 1 5.65434 1 5.45455H-1ZM1.36365 7.8182H5.45455V5.8182H1.36365V7.8182ZM5.45455 7.8182C6.75888 7.8182 7.8182 6.75894 7.8182 5.45455H5.8182C5.8182 5.65434 5.65434 5.8182 5.45455 5.8182V7.8182ZM7.8182 5.45455V1.36365H5.8182V5.45455H7.8182ZM7.8182 1.3636C7.81814 0.0592881 6.75892 -1 5.45455 -1V1C5.6543 1 5.81819 1.16383 5.8182 1.36369L7.8182 1.3636ZM5.13636 5.45455C5.13636 5.27812 5.27812 5.13636 5.45455 5.13636V7.13636C6.38269 7.13636 7.13636 6.38269 7.13636 5.45455H5.13636ZM5.45455 5.13636H1.36365V7.13636H5.45455V5.13636ZM1.36365 5.13636C1.54008 5.13636 1.68184 5.27812 1.68184 5.45455H-0.318161C-0.318161 6.38269 0.43551 7.13636 1.36365 7.13636V5.13636ZM1.68184 5.45455V1.36365H-0.318161V5.45455H1.68184ZM1.68184 1.36365C1.68184 1.54008 1.54008 1.68184 1.36365 1.68184V-0.318161C0.435509 -0.318161 -0.318161 0.435509 -0.318161 1.36365H1.68184ZM1.36365 1.68184H5.45455V-0.318161H1.36365V1.68184ZM5.45455 1.68184C5.27812 1.68184 5.13636 1.54008 5.13636 1.36365H7.13636C7.13636 0.43551 6.38269 -0.318161 5.45455 -0.318161V1.68184ZM5.13636 1.36365V5.45455H7.13636V1.36365H5.13636Z"
            fill="#CC3366"
            mask="url(#path-1-inside-1_53_585)"
          />
          <mask id="path-3-inside-2_53_585" fill="white">
            <path d="M13.6364 0H9.54553C8.79344 0 8.18188 0.611558 8.18188 1.36365V5.45455C8.18188 6.20661 8.79344 6.8182 9.54553 6.8182H13.6364C14.3885 6.8182 15.0001 6.20664 15.0001 5.45455V1.36365C15 0.611558 14.3885 0 13.6364 0ZM14.3182 5.45455C14.3182 5.8304 14.0123 6.13636 13.6364 6.13636H9.54553C9.16968 6.13636 8.86372 5.8304 8.86372 5.45455V1.36365C8.86372 0.987794 9.16968 0.681839 9.54553 0.681839H13.6364C14.0123 0.681839 14.3182 0.987794 14.3182 1.36365V5.45455Z" />
          </mask>
          <path
            d="M13.6364 0H9.54553C8.79344 0 8.18188 0.611558 8.18188 1.36365V5.45455C8.18188 6.20661 8.79344 6.8182 9.54553 6.8182H13.6364C14.3885 6.8182 15.0001 6.20664 15.0001 5.45455V1.36365C15 0.611558 14.3885 0 13.6364 0ZM14.3182 5.45455C14.3182 5.8304 14.0123 6.13636 13.6364 6.13636H9.54553C9.16968 6.13636 8.86372 5.8304 8.86372 5.45455V1.36365C8.86372 0.987794 9.16968 0.681839 9.54553 0.681839H13.6364C14.0123 0.681839 14.3182 0.987794 14.3182 1.36365V5.45455Z"
            fill="#CC3366"
          />
          <path
            d="M15.0001 1.36365H16.0001V1.3636L15.0001 1.36365ZM13.6364 -1H9.54553V1H13.6364V-1ZM9.54553 -1C8.24116 -1 7.18188 0.0592752 7.18188 1.36365H9.18188C9.18188 1.16384 9.34573 1 9.54553 1V-1ZM7.18188 1.36365V5.45455H9.18188V1.36365H7.18188ZM7.18188 5.45455C7.18188 6.75888 8.24114 7.8182 9.54553 7.8182V5.8182C9.34574 5.8182 9.18188 5.65434 9.18188 5.45455H7.18188ZM9.54553 7.8182H13.6364V5.8182H9.54553V7.8182ZM13.6364 7.8182C14.9408 7.8182 16.0001 6.75894 16.0001 5.45455H14.0001C14.0001 5.65434 13.8362 5.8182 13.6364 5.8182V7.8182ZM16.0001 5.45455V1.36365H14.0001V5.45455H16.0001ZM16.0001 1.3636C16 0.0592885 14.9408 -1 13.6364 -1V1C13.8362 1 14.0001 1.16383 14.0001 1.36369L16.0001 1.3636ZM13.3182 5.45455C13.3182 5.27812 13.46 5.13636 13.6364 5.13636V7.13636C14.5646 7.13636 15.3182 6.38269 15.3182 5.45455H13.3182ZM13.6364 5.13636H9.54553V7.13636H13.6364V5.13636ZM9.54553 5.13636C9.72196 5.13636 9.86372 5.27812 9.86372 5.45455H7.86372C7.86372 6.38269 8.61739 7.13636 9.54553 7.13636V5.13636ZM9.86372 5.45455V1.36365H7.86372V5.45455H9.86372ZM9.86372 1.36365C9.86372 1.54008 9.72196 1.68184 9.54553 1.68184V-0.318161C8.61739 -0.318161 7.86372 0.435512 7.86372 1.36365H9.86372ZM9.54553 1.68184H13.6364V-0.318161H9.54553V1.68184ZM13.6364 1.68184C13.46 1.68184 13.3182 1.54008 13.3182 1.36365H15.3182C15.3182 0.43551 14.5646 -0.318161 13.6364 -0.318161V1.68184ZM13.3182 1.36365V5.45455H15.3182V1.36365H13.3182Z"
            fill="#CC3366"
            mask="url(#path-3-inside-2_53_585)"
          />
          <mask id="path-5-inside-3_53_585" fill="white">
            <path d="M5.45455 8.18164H1.36365C0.611558 8.18164 0 8.7932 0 9.54529V13.6362C0 14.3882 0.611558 14.9998 1.36365 14.9998H5.45455C6.20661 14.9998 6.8182 14.3883 6.8182 13.6362V9.54529C6.81817 8.7932 6.20661 8.18164 5.45455 8.18164ZM6.13636 13.6362C6.13636 14.012 5.8304 14.318 5.45455 14.318H1.36365C0.987794 14.318 0.681839 14.012 0.681839 13.6362V9.54529C0.681839 9.16943 0.987794 8.86348 1.36365 8.86348H5.45455C5.8304 8.86348 6.13636 9.16943 6.13636 9.54529V13.6362Z" />
          </mask>
          <path
            d="M5.45455 8.18164H1.36365C0.611558 8.18164 0 8.7932 0 9.54529V13.6362C0 14.3882 0.611558 14.9998 1.36365 14.9998H5.45455C6.20661 14.9998 6.8182 14.3883 6.8182 13.6362V9.54529C6.81817 8.7932 6.20661 8.18164 5.45455 8.18164ZM6.13636 13.6362C6.13636 14.012 5.8304 14.318 5.45455 14.318H1.36365C0.987794 14.318 0.681839 14.012 0.681839 13.6362V9.54529C0.681839 9.16943 0.987794 8.86348 1.36365 8.86348H5.45455C5.8304 8.86348 6.13636 9.16943 6.13636 9.54529V13.6362Z"
            fill="#CC3366"
          />
          <path
            d="M6.8182 9.54529H7.8182V9.54524L6.8182 9.54529ZM5.45455 7.18164H1.36365V9.18164H5.45455V7.18164ZM1.36365 7.18164C0.0592739 7.18164 -1 8.24091 -1 9.54529H1C1 9.34548 1.16384 9.18164 1.36365 9.18164V7.18164ZM-1 9.54529V13.6362H1V9.54529H-1ZM-1 13.6362C-1 14.9405 0.0592577 15.9998 1.36365 15.9998V13.9998C1.16386 13.9998 1 13.836 1 13.6362H-1ZM1.36365 15.9998H5.45455V13.9998H1.36365V15.9998ZM5.45455 15.9998C6.75888 15.9998 7.8182 14.9406 7.8182 13.6362H5.8182C5.8182 13.836 5.65434 13.9998 5.45455 13.9998V15.9998ZM7.8182 13.6362V9.54529H5.8182V13.6362H7.8182ZM7.8182 9.54524C7.81814 8.24093 6.75892 7.18164 5.45455 7.18164V9.18164C5.6543 9.18164 5.81819 9.34547 5.8182 9.54533L7.8182 9.54524ZM5.13636 13.6362C5.13636 13.4598 5.27812 13.318 5.45455 13.318V15.318C6.38269 15.318 7.13636 14.5643 7.13636 13.6362H5.13636ZM5.45455 13.318H1.36365V15.318H5.45455V13.318ZM1.36365 13.318C1.54008 13.318 1.68184 13.4598 1.68184 13.6362H-0.318161C-0.318161 14.5643 0.435509 15.318 1.36365 15.318V13.318ZM1.68184 13.6362V9.54529H-0.318161V13.6362H1.68184ZM1.68184 9.54529C1.68184 9.72172 1.54008 9.86348 1.36365 9.86348V7.86348C0.435511 7.86348 -0.318161 8.61715 -0.318161 9.54529H1.68184ZM1.36365 9.86348H5.45455V7.86348H1.36365V9.86348ZM5.45455 9.86348C5.27812 9.86348 5.13636 9.72172 5.13636 9.54529H7.13636C7.13636 8.61715 6.38269 7.86348 5.45455 7.86348V9.86348ZM5.13636 9.54529V13.6362H7.13636V9.54529H5.13636Z"
            fill="#CC3366"
            mask="url(#path-5-inside-3_53_585)"
          />
          <mask id="path-7-inside-4_53_585" fill="white">
            <path d="M13.2955 11.25H11.9318V9.88633C11.9318 9.69789 11.7793 9.54541 11.5909 9.54541C11.4025 9.54541 11.25 9.69789 11.25 9.88633V11.25H9.88633C9.69789 11.25 9.54541 11.4025 9.54541 11.5909C9.54541 11.7793 9.69789 11.9318 9.88633 11.9318H11.25V13.2954C11.25 13.4839 11.4025 13.6363 11.5909 13.6363C11.7794 13.6363 11.9318 13.4839 11.9318 13.2954V11.9318H13.2955C13.4839 11.9318 13.6364 11.7793 13.6364 11.5909C13.6364 11.4025 13.4839 11.25 13.2955 11.25Z" />
          </mask>
          <path
            d="M13.2955 11.25H11.9318V9.88633C11.9318 9.69789 11.7793 9.54541 11.5909 9.54541C11.4025 9.54541 11.25 9.69789 11.25 9.88633V11.25H9.88633C9.69789 11.25 9.54541 11.4025 9.54541 11.5909C9.54541 11.7793 9.69789 11.9318 9.88633 11.9318H11.25V13.2954C11.25 13.4839 11.4025 13.6363 11.5909 13.6363C11.7794 13.6363 11.9318 13.4839 11.9318 13.2954V11.9318H13.2955C13.4839 11.9318 13.6364 11.7793 13.6364 11.5909C13.6364 11.4025 13.4839 11.25 13.2955 11.25Z"
            fill="#CC3366"
          />
          <path
            d="M11.9318 11.25H10.9318V12.25H11.9318V11.25ZM11.25 11.25V12.25H12.25V11.25H11.25ZM11.25 11.9318H12.25V10.9318H11.25V11.9318ZM11.9318 11.9318V10.9318H10.9318V11.9318H11.9318ZM13.2955 10.25H11.9318V12.25H13.2955V10.25ZM12.9318 11.25V9.88633H10.9318V11.25H12.9318ZM12.9318 9.88633C12.9318 9.14561 12.3316 8.54541 11.5909 8.54541V10.5454C11.227 10.5454 10.9318 10.2502 10.9318 9.88633H12.9318ZM11.5909 8.54541C10.8502 8.54541 10.25 9.14561 10.25 9.88633H12.25C12.25 10.2502 11.9547 10.5454 11.5909 10.5454V8.54541ZM10.25 9.88633V11.25H12.25V9.88633H10.25ZM11.25 10.25H9.88633V12.25H11.25V10.25ZM9.88633 10.25C9.14561 10.25 8.54541 10.8502 8.54541 11.5909H10.5454C10.5454 11.9547 10.2502 12.25 9.88633 12.25V10.25ZM8.54541 11.5909C8.54541 12.3316 9.1456 12.9318 9.88633 12.9318V10.9318C10.2502 10.9318 10.5454 11.2271 10.5454 11.5909H8.54541ZM9.88633 12.9318H11.25V10.9318H9.88633V12.9318ZM10.25 11.9318V13.2954H12.25V11.9318H10.25ZM10.25 13.2954C10.25 14.0362 10.8502 14.6363 11.5909 14.6363V12.6363C11.9548 12.6363 12.25 12.9316 12.25 13.2954H10.25ZM11.5909 14.6363C12.3316 14.6363 12.9318 14.0362 12.9318 13.2954H10.9318C10.9318 12.9316 11.2271 12.6363 11.5909 12.6363V14.6363ZM12.9318 13.2954V11.9318H10.9318V13.2954H12.9318ZM11.9318 12.9318H13.2955V10.9318H11.9318V12.9318ZM13.2955 12.9318C14.0362 12.9318 14.6364 12.3316 14.6364 11.5909H12.6364C12.6364 11.227 12.9316 10.9318 13.2955 10.9318V12.9318ZM14.6364 11.5909C14.6364 10.8501 14.0361 10.25 13.2955 10.25V12.25C12.9317 12.25 12.6364 11.9548 12.6364 11.5909H14.6364Z"
            fill="#CC3366"
            mask="url(#path-7-inside-4_53_585)"
          />
        </svg>
      ),
    },
    {
      url: '/gameficacao',
      description: 'Gameficação',
      bgcColor: '#996633',

      icon: (isSelected) => (
        <BsController
          size={ICON_SIZE}
          color={isSelected ? '#fff' : '#996633'}
        />
      ),
    },
    {
      url: '/gestao-usuarios',
      description: 'Gestão de Usuários',
      bgcColor: '#0062C7',
      icon: (isSelected) => (
        <FaRegUser size={ICON_SIZE} color={isSelected ? '#fff' : '#0062C7'} />
      ),
    },
    {
      url: '/pushs',
      description: 'Notificações',
      bgcColor: '#FF9933',
      icon: (isSelected) => (
        <FaRegBell size={ICON_SIZE} color={isSelected ? '#fff' : '#FF9933'} />
      ),
    },
    {
      url: '/novidades',
      description: 'Novidades',
      bgcColor: '#6699FF',
      icon: (isSelected) => (
        <FaRegNewspaper
          size={ICON_SIZE}
          color={isSelected ? '#fff' : '#6699FF'}
        />
      ),
    },
    {
      url: '/faqs',
      description: 'Perguntas Frequentes',
      bgcColor: '#CC6633',
      icon: (isSelected) => (
        <svg
          width="17"
          height="17"
          viewBox="0 0 17 17"
          fill="none"
          stroke={isSelected ? '#fff' : '#CC6633'}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 14.5127L14.9419 11.5374C15.4398 10.5457 15.6888 9.42994 15.6888 8.31421C15.6888 6.39268 14.9419 4.53317 13.5726 3.16951C12.2033 1.80584 10.3983 1 8.46888 1C7.47303 1 6.47718 1.18598 5.54357 1.55789C4.6722 1.9298 3.86307 2.48767 3.17842 3.16951C2.49378 3.85134 1.93361 4.65713 1.56017 5.52491C1.18672 6.45469 1 7.44645 1 8.43821C1 10.3597 1.80913 12.1573 3.17842 13.521C4.54772 14.8846 6.41494 15.6284 8.3444 15.6284C9.46473 15.6284 10.5851 15.3805 11.5809 14.8846L14.5685 15.9384C14.6929 16.0003 14.8174 16.0004 14.9419 16.0004C15.1909 16.0004 15.5021 15.8764 15.6888 15.6904C16 15.3805 16.0622 14.9466 15.9378 14.5747L16 14.5127ZM15.1286 15.0086C15.1286 15.0086 15.0664 15.0706 14.9419 15.0706L11.7676 13.9549C11.7054 13.9549 11.6432 13.9549 11.6432 13.9549C11.5809 13.9549 11.5187 13.9549 11.4564 14.0169C10.5228 14.5127 9.46473 14.7606 8.46888 14.7606C4.9834 14.7606 2.05809 11.9094 1.99585 8.43821C1.99585 6.70263 2.61826 5.02904 3.86307 3.78935C5.10788 2.54965 6.78838 1.8678 8.53112 1.92978C12.0166 1.99177 14.8797 4.90506 14.8797 8.37621C14.8797 9.42995 14.6307 10.4837 14.1328 11.3515C14.0705 11.4755 14.0705 11.5994 14.1328 11.7234L15.2531 14.8846C15.3154 14.9466 15.2531 15.0706 15.1909 15.0706L15.1286 15.0086Z"
            fill="#CC6633"
            stroke="#CC6633"
            strokeWidth="0.0722919"
            strokeMiterlimit="22.9256"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.28188 11.5376C8.03291 11.5376 7.84619 11.7236 7.84619 11.9715C7.84619 12.2195 8.03291 12.4054 8.28188 12.4054C8.53084 12.4054 8.71756 12.2195 8.71756 11.9715C8.71756 11.7236 8.53084 11.5376 8.28188 11.5376Z"
            fill="#CC6633"
            stroke="#CC6633"
            strokeWidth="0.0722919"
            strokeMiterlimit="22.9256"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.28241 4.65721C7.0376 4.65721 6.04175 5.64899 6.04175 6.8887C6.04175 7.13664 6.22847 7.3226 6.47743 7.3226C6.7264 7.3226 6.91312 7.13664 6.91312 6.8887C6.91312 6.14487 7.53552 5.58701 8.22017 5.58701C8.96706 5.58701 9.52723 6.20686 9.52723 6.8887C9.52723 7.63253 8.90482 8.19039 8.22017 8.19039C7.97121 8.19039 7.78449 8.37635 7.78449 8.62429V10.4219C7.78449 10.6698 7.97121 10.8558 8.22017 10.8558C8.46913 10.8558 8.65586 10.6698 8.65586 10.4219V8.99619C9.65171 8.81023 10.4608 7.88045 10.4608 6.8267C10.4608 5.58699 9.46499 4.59521 8.22017 4.59521L8.28241 4.65721Z"
            fill="#CC6633"
            stroke="#CC6633"
            strokeWidth="0.0722919"
            strokeMiterlimit="22.9256"
          />
        </svg>
      ),
    },
    {
      url: '/gestaoPerfil',
      bgcColor: '#CCCC33',
      description: 'Permissões de acesso',
      icon: (isSelected) => (
        <FaLightbulb size={ICON_SIZE} color={isSelected ? '#fff' : '#CCCC33'} />
      ),
    },
    {
      url: '/reports',
      bgcColor: '#00CCFF',
      description: 'Relatórios',
      isPublicAccess: true,
      allowedAccessGestorSSE: true,
      icon: (isSelected) => (
        <FaChartPie size={ICON_SIZE} color={isSelected ? '#fff' : '#00CCFF'} />
      ),
    },
    {
      url: '/servicos',
      description: 'Serviços: dashboard',
      bgcColor: '#808080',
      icon: (isSelected) => (
        <FaSitemap size={ICON_SIZE} color={isSelected ? '#fff' : '#00CCFF'} />
      ),
    },
    {
      url: '/tabelas-de-controle',
      description: 'Tabelas de Controle',
      bgcColor: '#0061C6',
      isPublicAccess: false,
      allowedAccessGestorSSE: true,
      icon: (isSelected) => (
        <MdContentCopy
          size={ICON_SIZE}
          color={isSelected ? '#fff' : '#0061C6'}
        />
      ),
    },
  ],
};

const Sidebar = () => {
  const [showMenu, setShowMenu] = useState(true);
  const urlSelected = window?.location?.pathname;
  const [allowedItems, setAllowedItems] = useState([]);
  const [canChangeLayout, setCanChangeLayout] = useState(false);

  useEffect(() => {

    const fetchAllowedItems = async () => {
      const items = [];
      const isAdminRole = await hasAdminRole();
      const isGestorSSERole = await hasGestorSSERole();
      for (const pg of pages.notAuth) {
        const allowed = !!isAdminRole || !!pg?.isPublicAccess || !!(pg?.allowedAccessGestorSSE && isGestorSSERole);
        if (allowed) {
          items.push(pg);
        }
      }
      setAllowedItems(items);
      const changeLayout = isAdminRole || isGestorSSERole;
      setCanChangeLayout(changeLayout);
    };
    fetchAllowedItems();
  }, []);

  const {setNewLayout} = useApp()

  const handleToNewLayout = () => {
    setNewLayout(true);
    inPersistentStore.setItem('newLayout', true);
  }

  
  return (
    <AuthContext.Consumer>
      {({ authenticated }) => {
        return (
            <div id="mainSidebar" className={showMenu ? 'showMenu' : ''}>
              <nav>
                <ul onClick={() => setShowMenu(false)}>
                  {!authenticated && pages.auth.map((pg, idx) => (
                      <div key={idx.toString()} style={{ position: 'relative', fontFamily: 'Montserrat' }}>
                        <li>
                          <Link to={pg.url}>
                            {pg.icon()}
                            {pg.description}
                          </Link>
                        </li>
                      </div>
                  ))}
                  {
                    authenticated && allowedItems.map((pg, idx) => {
                      const isSelected = urlSelected?.includes(pg.url);
                      return (
                          <div key={idx.toString()} style={{position: 'relative'}}>
                            <li
                                style={{
                                  backgroundColor:
                                      isSelected ? pg.bgcColor : '#fff',
                                }}
                            >
                              <Link to={pg.url}>
                                {pg.icon(isSelected)}
                                <p
                                    style={{
                                      color: isSelected ? '#fff' : '#8a8a8a',
                                      marginLeft: 5,
                                    }}
                                >
                                  {' '}
                                  {pg.description}
                                </p>
                              </Link>
                            </li>
                            {isSelected && (
                                <div
                                    style={{
                                      width: 0,
                                      position: 'absolute',
                                      top: 0,
                                      right: -20,
                                      height: 0,
                                      borderTop: '23px solid transparent',
                                      borderBottom: '23px solid transparent',
                                      borderLeft: `20px solid ${pg.bgcColor}`,
                                      zIndex: 100,
                                    }}
                                />
                            )}
                          </div>
                      )
                    })}
                  <div style={{height: 50}}/>


                </ul>
              </nav>
              {
                canChangeLayout && (
                <div style={{
                  fontSize: '13px',
                  margin: '0 auto',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'center'}}>
                  <a href="#/" onClick={() => handleToNewLayout()} style={{color: '#0061c6'}}>Alternar layout</a>
                </div>
                )
              }

            </div>
        )
      }}
    </AuthContext.Consumer>
  );
};

export default Sidebar;
